export default "__VITE_ASSET__D39jc_z7__"